import { render, staticRenderFns } from "./myVehicleList.vue?vue&type=template&id=72bf3b96&scoped=true"
import script from "./myVehicleList.vue?vue&type=script&lang=js"
export * from "./myVehicleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf3b96",
  null
  
)

export default component.exports